import PropTypes from 'prop-types';
import { DropDown } from '@web-stories-wp/design-system';
import { MULTIPLE_DISPLAY_VALUE, MULTIPLE_VALUE } from '../../../../constants';
import { FieldRow } from './textEffectStyles';

export default function TextEffectSelect({
  label,
  visibleLabel,
  options,
  value,
  onChange,
}) {
  return (
    <FieldRow>
      <span>{visibleLabel}</span>
      <DropDown
        ariaLabel={label}
        options={options}
        selectedValue={value === MULTIPLE_VALUE ? '' : value}
        placeholder={value === MULTIPLE_VALUE ? MULTIPLE_DISPLAY_VALUE : ''}
        onMenuItemClick={(_event, next) => onChange(next)}
      />
    </FieldRow>
  );
}

TextEffectSelect.propTypes = {
  label: PropTypes.string.isRequired,
  visibleLabel: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
